import { useLocalStorage } from "react-use";
import { getBankImportI18n } from "@rentablo/bank-import";
import i18n from "./i18n";

export const LANGUAGE_STORAGE_KEY = "rentablo-ui-language";

export const useStoredLanguage = () => {
  const [language, setLanguage] = useLocalStorage<"de" | "en" | undefined>(
    LANGUAGE_STORAGE_KEY,
    undefined,
    { raw: true }
  );

  const setNewLanguage = async (next: "de" | "en") => {
    setLanguage(next);
    await i18n.changeLanguage(next);
    await getBankImportI18n().changeLanguage(next);
  };

  return {
    language,
    setLanguage: setNewLanguage,
  };
};

export const getStoredLanguage = (): "de" | "en" | undefined => {
  if (typeof window === "undefined") return;
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
  } catch {
    // ignore storage failures (private mode, disabled storage, etc.)
  }
  return;
};
